<template>
<div class="contentBox accountInfoPage">
    <div class="pageTitle">
        <h1>账号信息</h1>
    </div>
    <div class="accountInfoBox">
        <div class="left">
            <div class="header">
                <span :class="{ active: tab === 'account' }" @click="changeTab('account')">基本信息</span>
                <span :class="{ active: tab === 'bind' }" @click="changeTab('bind')">账号绑定</span>
                <span :class="{ active: tab === 'personalise' }" @click="changeTab('personalise')">个性化</span>
                <span :class="{ active: tab === 'bill' }" @click="changeTab('bill')">发票信息</span>
                <span :class="{ active: tab === 'security' }" @click="changeTab('security')">账号安全</span>
            </div>
            <div v-if="tab === 'account'" class="info">
                <div class="infoItem">
                    <span class="label">昵称</span>
                    <el-input class="w600" v-model="sponsor.nickName" />
                </div>
                <div class="infoItem">
                    <span class="label">头像</span>
                    <div class="w600 upLoadHeader">
                        <el-form :model="form1">
                            <el-form-item>
                                <el-upload ref="upload" 
                                    action="#" 
                                    accept="image/png,image/gif,image/jpg,image/jpeg" 
                                    list-type="picture-card"
                                    :auto-upload="false"
                                    :file-list="portraitList"
                                    :on-exceed="handleExceed" 
                                    :before-upload="handleBeforeUpload" 
                                    :on-preview="handlePictureCardPreview" 
                                    :on-remove="handleRemove"
                                    :on-change="handleChangePic"
                                >
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>

                                <el-dialog :visible.sync="dialogVisible">
                                    <img width="100%" :src="dialogImageUrl" alt="">
                                </el-dialog>
                            </el-form-item>
                            <!-- <el-form-item>
                                <el-button size="small" type="primary" @click="uploadFile">立即上传</el-button>
                                <el-button size="small">取消</el-button>
                            </el-form-item> -->
                        </el-form>
                    </div>
                </div>
                <div class="infoItem">
                    <span class="label">介绍</span>
                    <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="sponsor.intro" class="w600" resize="none"></el-input>
                </div>
                <div class="actionBtnBox">
                    <button class="submitBtn" @click="saveGeneralInfo">提交</button>
                </div>
            </div>
            <div v-if="tab === 'bind'" class="info wechat">
                    <div class="tips">
                        <p v-if="!wechat || wechat === ''">可使用微信扫码登录，更便捷；还可以通过Quicklive公众号接收系统重要信息</p>
                        <p v-else>已绑定</p>
                        <button @click="getWechatQrCode">
                            <img src="../../../assets/weixin.svg" alt  /> {{bindButtonTitle}}
                        </button>
                    </div>
                    <div v-if="showQrCode">
                        <img :src="qrCodeData" alt class="qrcode" />
                        <div class="qrcodeTips">扫上方二维码关注Quicklive公众号完成绑定</div>
                    </div>
            </div>
            <div v-if="tab === 'personalise'" class="info">
                <div v-if="sponsor.portalType === 1">
                    <div class="personaliseTitle">个性化网站</div>
                    <p>尊贵的VIP用户，您已启用个性化首页，地址为：</p>
                    <div class="domainName">
                        <!--<el-input class="domainInput" v-model="homePageUrl"/>-->
                        <span class="main">{{sponsor.url}}</span>
                        <button class="myHome" @click="jumpPage('/index')">我的首页</button>
                    </div>
                </div>
                <!--<div v-else>-->
                    <div class="personaliseTitle">个性化logo
                        <el-popover
                                placement="top-start"
                                title="Logo是什么"
                                width="480"
                                trigger="hover">
                            <div>
                                <img src="../../../assets/what-is-logo.png" style="width:100%;"/>
                                <ul>
                                    <li>Logo会显示在您的直播间首页和每个频道的左上角；</li>
                                    <li>建议使用背景透明的png格式；</li>
                                    <li>Logo显示区域较小，使用接近推荐尺寸即可。</li>
                                </ul>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </div>
                    <div class="logoBox">
                        <img :src="sponsor.indLogo" alt/>
                    </div>
                    <div class="uploadBtnBox">
                        <button class="uploadBtn">上传图像</button>
                        <p class="tips">建议尺寸：180x60，背景透明</p>
                        <div class="uploadLogo">
                            <el-form :model="form2">
                                <el-form-item>
                                    <el-upload ref="upload"
                                               action="#"
                                               accept="image/png,image/gif"
                                               list-type="picture-card"
                                               :auto-upload="false"
                                               :on-exceed="handleExceed"
                                               :before-upload="handleBeforeUpload"
                                               :on-preview="handlePictureCardPreview"
                                               :on-remove="handleRemove"
                                               :on-change="handleChangePicLogo"
                                    >
                                        <i class="el-icon-plus avatar-uploader-icon"></i>
                                        <span class="uploadTips">上传图片</span>
                                    </el-upload>
                                    <el-dialog :visible.sync="dialogVisible">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                    </el-dialog>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="personaliseTitle lastTitle">直播间首页banner
                        <el-popover
                                placement="top-start"
                                title="Banner是什么"
                                width="480"
                                trigger="hover">
                            <div>
                                <img src="../../../assets/what-is-banner.png" style="width:100%;"/>
                                <ul>
                                    <li>Banner在直播间首页顶部显示；</li>
                                    <li>建议不小于建议尺寸，如果现有内容宽度不足，可通过合适的底色扩大图片，保证banner的整体效果；</li>
                                    <li>高于建议尺寸的内容会被居中裁切。</li>
                                </ul>
                            </div>
                            <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                    </div>
                    <div class="bannerBox">
                        <img :src="sponsor.indBanner" alt/>
                    </div>
                    <div class="uploadBtnBox">
                        <button class="uploadBtn">上传图像</button>
                        <p class="tips">尺寸建议：3840x250，宽度不小于1920</p>
                        <div class="uploadBanner">
                            <el-form :model="form3">
                                <el-form-item>
                                    <el-upload ref="upload"
                                               action="#"
                                               accept="image/png,image/gif,image/jpg,image/jpeg"
                                               list-type="picture-card"
                                               :auto-upload="false"
                                               :on-exceed="handleExceed"
                                               :before-upload="handleBeforeUpload"
                                               :on-preview="handlePictureCardPreview"
                                               :on-remove="handleRemove"
                                               :on-change="handleChangePicBanner"
                                    >
                                        <i class="el-icon-plus avatar-uploader-icon"></i>
                                        <span class="uploadTips">上传图片</span>
                                    </el-upload>

                                    <el-dialog :visible.sync="dialogVisible">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                    </el-dialog>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                <!--</div>-->
            </div>
            <div v-if="tab === 'bill'" class="info">
                <el-form :model="ext" :rules="parseInt(ext.billType) === 0? billRulesOrdinary : billRulesSpecial" ref="billForm" label-width="110px" class="bill-form">
                    <el-form-item label="类型" prop="billType">
                        <el-radio-group v-model="ext.billType" @change="billTypeChange">
                            <el-radio-button :label="0">增值税普通发票</el-radio-button>
                            <el-radio-button :label="1">增值税专用发票</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="名称" prop="billTitle">
                        <el-input v-model.trim="ext.billTitle"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号" prop="billSerial">
                        <el-input v-model.trim="ext.billSerial"></el-input>
                    </el-form-item>
                    <el-form-item label="地址、电话" prop="billAddress">
                        <el-input v-model.trim="ext.billAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行及账号" prop="billBank">
                        <el-input v-model.trim="ext.billBank"></el-input>
                    </el-form-item>
                    <el-divider content-position="left">邮寄信息</el-divider>
                    <el-form-item label="联系人" prop="receiver">
                        <el-input v-model.trim="ext.receiver"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="receiverPhone">
                        <el-input v-model.trim="ext.receiverPhone" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="邮寄地址" prop="address">
                        <el-input v-model.trim="ext.address"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="saveBillInfo" :loading="savingAccount">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="tab === 'security'" class="info security">
                <div class="tips">
                    <p><i class="el-icon-success check"></i>绑定手机</p>
                    <p v-if="wechat && wechat !== ''"><i class="el-icon-success check"></i>绑定微信</p>
                    <p v-else><i class="el-icon-warning uncheck"></i>未绑定，去【账号绑定】栏绑定微信接收重要消息</p>
                    <el-divider><i class="el-icon-key"></i></el-divider>
                    <el-form :model="security" :rules="passwordRules" ref="pwdForm" label-width="110px">
                        <el-form-item label="旧密码" prop="oldPassword">
                            <el-input placeholder="请输入旧密码" v-model="security.oldPassword" show-password class="w300"></el-input>
                        </el-form-item>
                        <el-form-item label="新密码" prop="newPassword">
                            <el-input placeholder="请输入新密码" v-model="security.newPassword" show-password class="w300"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="retypePassword">
                            <el-input placeholder="请再次输入新密码" v-model="security.retypePassword" show-password class="w300"></el-input>
                        </el-form-item>
                        <div style="margin-top: 36px;margin-left: 110px">
                            <el-button type="primary" @click="changePassword" :loading="savingPassword">修改密码</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="avatarInfo">
                <div class="avatarHeaderWrap">
                    <img :src="sponsor.portrait" alt />
                </div>
                <span>{{sponsor.nickName}}
                    <el-tooltip class="item" effect="dark" content="QUICKLIVE VIP" placement="top-end" v-if="!!sponsor.vip">
                        <i class="el-icon-s-check"></i>
                    </el-tooltip>
                </span>

            </div>
            <div class="mobile">
                <span>手机</span>
                <span>{{sponsor.phone}}</span>
            </div>
            <div class="userType">
                <span>用户类型</span>
                <span v-if="sponsor.type === 2" class="typeBadge organ"><i class="el-icon-school"></i>机构</span>
                <span class="typeBadge individual" v-else-if="sponsor.status === 2"><i class="el-icon-user"></i>机构认证待审</span>
                <span class="typeBadge individual" v-else-if="sponsor.status === 3"><i class="el-icon-user"></i>机构审核被拒</span>
                <span v-else class="typeBadge individual"><i class="el-icon-user"></i>个人</span>
                <p v-if="sponsor.type === 2">{{sponsor.organName}}</p>
                <button @click="jumpPage('/account/certification')" v-if="sponsor.type === 1 && [1,3].includes(sponsor.status)">申请机构认证</button>
                <!--<button @click="jumpPage('/account/certification')"></button>-->
                <el-link type="info" style="font-size: 10px;margin-left: 8px" @click="showCertInfo">认证资料</el-link>
            </div>
            <div class="desc">
                <div class="titleIntor">介绍</div>
                <p class="descText">{{sponsor.intro}}</p>
            </div>
        </div>
    </div>

    <el-drawer
            title="认证资料"
            :visible.sync="showCert"
            :wrapperClosable="false"
            size="640px">
        <el-divider content-position="left">实名认证({{cert.realName}})</el-divider>
        <el-image :src="cert.idCardFront" style="margin: 8px">
            <div slot="placeholder" class="image-slot">
                身份证<span class="dot">...</span>
            </div>
        </el-image>
        <el-image :src="cert.idCardBack" style="margin: 8px">
            <div slot="placeholder" class="image-slot">
                身份证背面<span class="dot">...</span>
            </div>
        </el-image>
        <el-divider content-position="left">机构认证({{cert.organName}})</el-divider>
        <el-image :src="cert.bizLic" v-if="cert.bizLic" style="margin: 8px">
            <div slot="placeholder" class="image-slot">
                营业执照<span class="dot">...</span>
            </div>
        </el-image>
        <el-image :src="cert.authorization" v-if="cert.authorization" style="margin: 8px">
            <div slot="placeholder" class="image-slot">
                授权书<span class="dot">...</span>
            </div>
        </el-image>
    </el-drawer>
</div>
</template>

<script>
    import common from '../../../common.vue';
    import OSS from 'ali-oss';

    export default {
        name: "AccountInfo",
        data() {
            const validatePhone = (rule, value, callback) =>{
                const phone = /^1\d{10}$/;
                if(value && !(phone.test(value))){
                    callback(new Error('联系电话格式不正确'))
                }else{
                    callback()
                }
            };
            const validatePassword = (rule, value, callback) =>{
                let pwd = value;
                if (pwd.length < 8 || /^[0-9]{1,8}$/.test(pwd)) {
                    callback(new Error('密码过短或为纯数字'))
                }else{
                    let strength = 0;
                    if (pwd.match(/[a-z]/g)) {
                        strength++;
                    }
                    if (pwd.match(/[A-Z]/g)) {
                        strength++;
                    }
                    if (pwd.match(/[0-9]/g)) {
                        strength++;
                    }
                    if (pwd.match(/[^a-zA-Z0-9]/g)) {
                        strength++;
                    }
                    if (pwd.length < 8 && strength > 1) {
                        strength = 1;
                    }
                    if(strength < 3){
                        callback(new Error('密码太过简单，必须包含大写字母、小字字母、数字和符号至少三种'));
                    }else{
                        callback();
                    }
                }
            };
            return {
                tab: "account",
                disabled: false,

                form1: {},
                form2: {},
                form3: {},

                dialogImageUrl: '',
                dialogVisible: false,
                // 是否显示认证资料
                showCert: false,

                // 账户基本信息
                sponsor: {},
                // 微信绑定openId,
                wechat: null,
                bindButtonTitle: '微信绑定',
                // 是否显示关注公众号二维码
                showQrCode: false,
                qrCodeData: null,
                // 扩展信息，包含开票信息
                ext: {},
                // 头像文件列表
                portraitList: [],
                // oss上传配置
                ossConfig: {},
                // 选择的新的头像
                portraitFile: null,
                // logo文件列表
                logoFileList: [],
                // banner文件列表
                bannerFileList: [],
                // 用于刷新绑定状态的timer
                timer: null,
                // 认证材料
                cert: {},
                // 是否正在保存用户信息
                savingAccount: false,
                billRulesOrdinary: {
                    billTitle: [
                        { required: true, message: '请输入发票抬头', trigger: 'blur' },
                        { min: 2, max: 128, message: '长度在 2 到 128 个字符', trigger: 'blur' }
                    ],
                    receiver: [
                        { required: true, message: '请输入联系人', trigger: 'blur' }
                    ],
                    receiverPhone: [
                        { type: '', required: true, message: '请选择日期', trigger: 'blur' },
                        {min: 7, max: 11, message: '请正确输入电话', trigger: 'blur'},
                        {validator: validatePhone, trigger: 'blur'}
                    ],
                    address: [
                        { required: true, message: '请输入邮寄地址', trigger: 'blur' }
                    ],
                },
                billRulesSpecial: {
                    billTitle: [
                        { required: true, message: '请输入发票抬头', trigger: 'blur' },
                        { min: 2, max: 128, message: '长度在 2 到 128 个字符', trigger: 'blur' }
                    ],
                    billSerial: [
                        { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
                        { min: 12, max: 32, message: '15/18/20位', trigger: 'blur' }
                    ],
                    billAddress: [
                        { required: true, message: '请输入地址、电话', trigger: 'blur' }
                    ],
                    billBank: [
                        { required: true, message: '请输入开户行和账号', trigger: 'blur' }
                    ],
                    receiver: [
                        { required: true, message: '请输入联系人', trigger: 'blur' }
                    ],
                    receiverPhone: [
                        { type: '', required: true, message: '请选择日期', trigger: 'blur' },
                        {min: 7, max: 11, message: '请正确输入电话', trigger: 'blur'},
                        {validator: validatePhone, trigger: 'blur'}
                    ],
                    address: [
                        { required: true, message: '请输入邮寄地址', trigger: 'blur' }
                    ],
                },
                passwordRules:{
                    oldPassword: [{ required: true, message:'请输入旧密码', trigger: 'blur' }],
                    newPassword: [
                        { required: true, message: '密码必须包含大写字母、小字字母、数字和符号至少三种', trigger: 'blur' },
                        {min: 8, message: '密码过短', trigger: 'blur'},
                        {validator: validatePassword, trigger: 'blur'}
                    ],
                    retypePassword: [
                        { type: '', required: true, message: '密码必须包含大写字母、小字字母、数字和符号至少三种', trigger: 'blur' },
                        {min: 8, message: '密码过短', trigger: 'blur'},
                        {validator: validatePassword, trigger: 'blur'}
                    ],
                },
                // 修改密码
                security:{
                    oldPassword: '',
                    newPassword: '',
                    retypePassword: '',
                },
                // 是否正在保存密码
                savingPassword: false
            };
        },
        methods: {
            changeTab(type) {
                this.tab = type;
            },
            jumpPage(path) {
                this.$router.push(`${path}`);
            },
            // 手机号禁止输入e.
            channelInputLimit(e) {
                let key = e.key;
                // 不允许输入'e'和'.'
                if (key === "e" || key === ".") {
                    e.returnValue = false;
                    return false;
                }
                return true;
            },
            // 发票类型发生变化，清除校验提示
            billTypeChange(){
                //this.$refs.billForm.resetFields();
                this.$refs.billForm.clearValidate();
            },
            // 上传文件之前的钩子
            handleBeforeUpload(file) {
                if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                    this.$notify.warning({
                        title: '警告',
                        message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
                    })
                }
                let size = file.size / 1024 / 1024 / 2;
                if (size > 2) {
                    this.$notify.warning({
                        title: '警告',
                        message: '图片大小必须小于2M'
                    })
                }
            },

            // 新上传的图片替换老的图片
            handleChangePic(file, fileList) {
                if (fileList.length > 1) {
                    fileList.splice(0, 1);
                }
                this.portraitFile = file.raw;
            },
            // 新上传的图片替换老的图片logo
            handleChangePicLogo(file, fileList) {
                let _this = this;
                if (fileList.length > 1) {
                    fileList.splice(0, 1);
                }
                _this.logoImgUrl = fileList[0].url;
                _this.ossUploadFile(file.raw,function (ossKey) {
                    _this.saveIndividualItem(ossKey, 'logo');
                })
            },
            // 新上传的图片替换老的图片logo
            handleChangePicBanner(file, fileList) {
                let _this = this;
                if (fileList.length > 1) {
                    fileList.splice(0, 1);
                }
                // 检查图片尺寸
                new Promise((resolve, reject) => {
                    const _URL = window.URL || window.webkitURL;
                    const img = new Image();
                    img.onload = () => {
                        (img.width >= 1920 && img.height >=250)? resolve() : reject(img.width, img.height);
                    };
                    img.src = _URL.createObjectURL(file.raw);
                }).then(
                    () => {
                        _this.logoImgUrl = fileList[0].url;
                        _this.ossUploadFile(file.raw,function (ossKey) {
                            _this.saveIndividualItem(ossKey, 'banner');
                        })
                    },
                    (w,h) => {
                        this.$message.warning('为了显示正常，个性Banner大小不应小于1920x250，选择图片尺寸：' + w + 'x' + h + "。");
                    }
                );
            },
            // 文件超出个数限制时的钩子
            handleExceed() {
                alert('只可以上传一个文件');
            },
            // 文件列表移除文件时的钩子
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            // 点击文件列表中已上传的文件时的钩子
            handlePictureCardPreview(file) {

                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleDownload(file) {
                console.log(file);
            },
            /**
             * 加载账号信息
             */
            loadInfo(){
                let _this = this;

                _this.$axios.post(common._BASE_ + '/sponsor/getInfo').then(function (res) {
                    let r = res.data;
                    if (r && r.code === 0) {
                        _this.sponsor = r.sponsor;
                        _this.portraitList = [{url:r.sponsor.portrait}];
                        _this.wechat = r.wechat;
                        _this.bindButtonTitle = (_this.wechat && _this.wechat !== ''? '更换账号' : '微信绑定');
                        _this.ext = r.ext;
                    }
                    r.code < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 获取oss上传授权
             */
            getCredential(callback){
                let _this = this;

                _this.$axios.post(common.OSS_CREDENTIAL_URL).then(function (res) {
                    let r = res.data;
                    if (r && r.code === 0) {
                        callback && callback(r);
                    }
                    r.code < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 根据服务器上返回的授权构建oss配置
             */
            buildConfig(credential){
               let _this = this;
               _this.ossConfig = Object.assign({
                   refreshSTSToken: async () => {
                       _this.getCredential(function(r){
                           return r;
                       });
                   }
               }, credential);
            },

            /**
             * 上传文件
             * @param file
             * @param callback
             */
            ossUploadFile(file, callback){
                if(!file){ return null; }

                let _this = this,
                    ossClient = new OSS(this.ossConfig),
                    fileName = common.guid() + "." + common.fileExt(file.name),
                    ossKey = common.assertPath(this.ossConfig.folder) + fileName;
                ossClient.put(ossKey, file).then(function(r){
                    console.info(r);
                    callback && callback(ossKey);
                }).catch(function (err) {
                    console.error('error: %j', err);
                    _this.$notify({
                        title: '错误',
                        message: err,
                        type: 'error'
                    });
                    return null;
                });
            },
            /**
             * 保存基本信息 昵称、头像、简介
             */
            saveGeneralInfo(){
                let _this = this;
                if(this.portraitFile){
                    this.ossUploadFile(this.portraitFile, function (ossKey) {
                        _this.doSaveGeneralInfo(ossKey);
                    });
                }else{
                    _this.doSaveGeneralInfo(null);
                }
            },
            /**
             * 提交保存数据
             */
            doSaveGeneralInfo(portraitKey){
                let _this = this;

                _this.savingAccount = true;
                _this.$axios.post(common._BASE_ + '/sponsor/saveGeneral',
                    _this.$qs.stringify({intro: _this.sponsor.intro, portrait: portraitKey, nickName: _this.sponsor.nickName})).then(function (res) {
                        _this.savingAccount = false;
                        let r = res.data;
                        if (r && r.code === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '信息保存成功',
                                type: 'success'
                            });
                        }
                        r.code < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 获取关注微信公众号的二维码
             */
            getWechatQrCode(){
                let _this = this;

                _this.$axios.post(common._BASE_ + '/sponsor/bindQrCode').then(function (res) {
                    let r = res.data;
                    if (r && r.data) {
                        _this.qrCodeData = r.data.qrCode;
                        _this.showQrCode = true;
                        _this.timer = setInterval(function(){
                            _this.queryBindStatus(r.data.sceneId);
                        }, 1000);
                    }
                    r.code < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 查询绑定状态
             */
            queryBindStatus(sceneId){
                let _this = this;

                _this.$axios.post(common._BASE_ + '/sponsor/queryBindInfo',
                    this.$qs.stringify({sceneId: sceneId})).then(function (res) {
                    let r = res.data;
                    if (r && r.code === 0 && r.wechat) {
                        clearInterval(_this.timer);
                        _this.timer = null;
                        _this.wechat = r.wechat;
                        _this.$notify({
                            title: '成功',
                            message: '微信绑定成功',
                            type: 'success'
                        });
                        _this.showQrCode = false;
                    }
                });
            },
            /**
             * 保存个性化配置
             * @param ossKey oss上的文件路径
             * @param item   所属项logo/banner
             */
            saveIndividualItem(ossKey, item){
                let _this = this;

                _this.$axios.post(common._BASE_ + '/sponsor/setIndItem',
                    this.$qs.stringify({type: item, filePath: ossKey})).then(function (res) {
                    let r = res.data;
                    if (r && r.code === 0) {
                        if(item === 'logo'){_this.sponsor.indLogo = r.value; }
                        else if(item === 'banner'){_this.sponsor.indBanner = r.value;}
                    }
                });
            },

            /**
             * 保存发票信息
             */
            saveBillInfo(){
                // 检查输入
                let ext = this.ext;
                if(common.isEmpty(ext.billTitle) ||
                    common.isEmpty(ext.receiver) ||
                    common.isEmpty(ext.receiverPhone) ||
                    common.isEmpty(ext.address)){
                    this.$message({
                        message: '请输入必填项',
                        type: 'warning',
                        duration: 2800
                    });
                    return;
                }
                let _this = this;

                if(!ext.sponsorId){ ext.sponsorId = _this.sponsor.sponsorId; }
                _this.$axios.post(common._BASE_ + '/sponsor/saveBill',
                    this.$qs.stringify(ext)).then(function (res) {
                    let r = res.data;
                    if (r && r.code === 0) {
                        _this.$notify({
                            title: '成功',
                            message: '发票信息保存成功',
                            type: 'success'
                        });
                    }
                });
            },

            changePassword(){
                console.info('修改密码');
                let p = this.security;
                if(common.isEmpty(p.oldPassword) ||
                    common.isEmpty(p.newPassword)){
                    this.$message({
                        message: '请输入必填项',
                        type: 'warning',
                        duration: 2800
                    });
                    return;
                }
                if(p.newPassword !== p.retypePassword){
                    this.$message({
                        message: '两次密码输入不一致',
                        type: 'warning',
                        duration: 2800
                    });
                    return;
                }
                if(common.passwordStrength(p.newPassword) < 3){
                    this.$message({
                        message: '密码强度不符合要求',
                        type: 'warning',
                        duration: 2800
                    });
                    return;
                }

                let _this = this, nonce = (new Date()).getTime();
                _this.savingPassword = true;
                let data = {
                    password: _this.$md5(p.newPassword),
                    oldPassword: _this.$md5(_this.$md5(p.oldPassword) + nonce),
                    nonce : nonce,
                };
                _this.$axios.post(common._BASE_ + '/sponsor/changePassword',
                    this.$qs.stringify(data)).then(function (res) {
                        _this.savingPassword = false;
                        let r = res.data;
                        if (r && r.code >= 0) {
                            _this.$notify({
                                title: '成功',
                                message: '密码修改成功',
                                type: 'success'
                            });
                            _this.security.oldPassword = '';
                            _this.security.newPassword = '';
                            _this.security.retypePassword = '';
                        }else{
                            _this.$notify({
                                title: '失败',
                                message: '旧密码不正确',
                                type: 'error'
                            });
                        }
                });
            },

            /**
             * 显示认证信息
             */
            showCertInfo(){
                this.showCert = true;
                let _this = this;

                _this.$axios.post(common._BASE_ + '/sponsor/certInfo').then(function (res) {
                    let r = res.data;
                    if (r && r.code === 0) {
                        _this.cert = r.cert;
                    }
                });
            }
        },
        mounted(){
            let _this = this;
            _this.loadInfo();
            _this.getCredential(function (c) {
                _this.buildConfig(c);
            });
        }
    };
</script> 

<style lang="less">
.accountInfoPage {
    .accountInfoBox {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .left,
        .right {
            background: #fff;
            border: solid 1px #e8e8e8;
            font-size: 14px;
        }

        .left {
            width: 950px;
            padding-bottom: 35px;

            .header {
                height: 59px;
                border-bottom: solid 1px #e8e8e8;
                font-size: 16px;
                font-weight: 400;
                padding-left: 49px;
                display: flex;
                align-items: center;

                span {
                    width: 65px;
                    height: 100%;
                    line-height: 59px;
                    text-align: center;
                    margin-right: 67px;
                    cursor: pointer;
                }

                span.active {
                    border-bottom: 2px solid #306ff6;
                    color: #306ff6;
                }
            }

            .info {
                padding-left: 50px;
                padding-top: 22px;
            }

            .wechat{
                button{
                    width: 149px;
                    height: 43px;
                    background: #59c24b;
                    border-radius: 6px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                    color: #ffffff;
                    margin-right: 20px;
                    margin-top: 8px;

                    img {
                        width: 27px;
                        margin-right: 14px;
                    }
                }
            }

            .infoItem {
                display: flex;
                margin-bottom: 12px;
            }

            .label {
                width: 82px;
                font-size: 14px;
                margin-top: 12px;
            }

            .w600 {
                width: 600px;
            }

            .el-upload--picture-card,
            .el-upload-list--picture-card .el-upload-list__item {
                width: 128px;
                height: 128px;
                border-radius: 128px;
                overflow: hidden;
                margin-right: 18px;
            }

            .userType {
                width: 722px;
            }

            .selectType {
                width: 140px;
            }

            .selectType {
                .el-input__inner::-webkit-input-placeholder {
                    color: #33363f;
                }

                .el-input__inner::-moz-input-placeholder {
                    color: #33363f;
                }

                .el-input__inner::-ms-input-placeholder {
                    color: #33363f;
                }
            }

            .userName {
                width: 450px;
                margin-left: 10px;
                margin-right: 12px;
            }

            .submit {
                width: 110px;
                height: 40px;
                background: #ffffff;
                border: 1px solid #c1c5c5;
                border-radius: 4px;
                font-size: 14px;
            }

            .submit:hover {
                background: #306ff6;
                color: #fff;
            }

            .actionBtnBox {
                padding-left: 82px;

                button {
                    width: 110px;
                    height: 40px;
                    border-radius: 4px;
                }

                .resetBtn {
                    background: #ffffff;
                    border: 1px solid #c1c5c5;
                }

                .resetBtn:hover {
                    background: #306ff6;
                    color: #fff;
                    border: none;
                }

                .submitBtn {
                    background: #076eff;
                    color: #fff;
                    margin-right: 22px;
                }

                .submitBtn:hover {
                    background: #4aa3f8;
                }
            }

            .billActionBtnBox {
                padding-left: 91px;
            }

            .bindInfo {
                font-size: 14px;
                display: flex;
                align-items: center;
            }

            .tips {
                margin-top: 13px;
                margin-bottom: 8px;
            }

            .qrcode {
                width: 125px;
                margin-bottom: 9px;
            }

            .personaliseTitle {
                color: #a2a9ab;
                font-weight: bold;
                margin-bottom: 13px;
            }

            .security{
                p{line-height: 24px}

                .check{
                    color:#67C23A;
                    font-size: 18px;
                    margin-right: 8px;
                }

                .uncheck{
                    margin-right: 8px;
                    color: #a2a9ab;
                    font-size: 18px;
                }

                .w300 {
                    width: 300px;
                    margin-bottom: 16px;
                    display: block;
                }
            }

            .lastTitle {
                margin-top: 22px;
            }

            .domainName {
                display: flex;
                align-items: center;
                margin-top: 13px;
                margin-bottom: 26px;

                .domainInput {
                    width: 495px;
                    margin-right: 14px;
                }

                .main {
                    color: #a2a9ab;
                }

                .myHome {
                    width: 99px;
                    height: 40px;
                    background: #ffffff;
                    border: 1px solid #c1c5c5;
                    border-radius: 4px;
                    margin-left: 25px;
                }

                .myHome:hover {
                    background: #306ff6;
                    color: #fff;
                    border: none;
                    margin-left: 25px;
                }
            }

            .logoBox {
                width: 180px;

                img {
                    width: 100%;
                    display: block;
                }
            }

            .bannerBox {
                width: 572px;

                img {
                    width: 100%;
                    display: block;
                }
            }

            .uploadBtnBox {
                position: relative;
                margin-top: 12px;
                display: flex;
                align-items: center;
                .uploadLogo,.uploadBanner{
                    position: absolute;
                    width: 128px;
                    height: 40px;
                    left: 0;
                    top: 0;
                    opacity: 0;
                    z-index: 100;
                    cursor: pointer;
                }

                .uploadBtn {
                    width: 128px;
                    height: 40px;
                    background: #ffffff;
                    border: 1px solid #c1c5c5;
                    border-radius: 4px;
                    color: #409EFF;
                }

                .tips {
                    color: #7e868c;
                    margin-left: 11px;
                }

                .el-upload-list{
                    display: none;
                }
            }

            .billItem {
                display: flex;
                align-items: center;
                margin-bottom: 12px;

                .title {
                    width: 91px;
                }
            }
        }

        .right {
            width: 240px;
            padding: 25px 23px 39px 25px;
            font-size: 14px;

            .avatarInfo {
                display: flex;
                flex-direction: column;
                align-items: center;

                .avatarHeaderWrap {
                    width: 128px;
                    height: 128px;
                    margin: 0 auto;
                    border-radius: 50%;

                    img {
                        width: 128px;
                        height: auto;
                        border-radius: 50%;
                    }
                }

                span {
                    font-size: 18px;
                    font-weight: bold;
                    color: #221816;
                    margin-top: 10px;
                }
                i{
                    color:#E6A23C
                }
            }

            .mobile {
                height: 36px;
                line-height: 36px;
                border-top: 1px solid #e8e8e8;
                border-bottom: 1px solid #e8e8e8;
                margin-top: 12px;
                margin-bottom: 7px;

                span:first-child {
                    color: #a2a9ab;
                    font-weight: bold;
                    margin-right: 35px;
                }
            }

            .userType {
                padding-bottom: 10px;
                border-bottom: 1px solid #f5f6f7;
                line-height: 36px;

                .typeBadge{
                    border-radius: 2px;
                    padding: 4px 12px 4px 12px;
                    color: white;
                    height: 24px;
                    line-height: 24px;
                    font-size: 10px;

                    i{
                        margin-right: 4px;
                    }
                }
                .individual{
                    background-color: #606266;
                }
                .organ{
                    background-color:#409EFF;
                }

                span:first-child {
                    color: #a2a9ab;
                    font-weight: bold;
                    margin-right: 8px;
                }

                p {
                    margin: 7px 0;
                }

                button {
                    width: 109px;
                    height: 30px;
                    background: #ffffff;
                    border: 1px solid #c1c5c5;
                    border-radius: 4px;
                }

                button:hover {
                    background: #306ff6;
                    color: #fff;
                    border: none;
                }
            }

            .desc {
                .titleIntor {
                    color: #a2a9ab;
                    font-weight: bold;
                    margin-bottom: 5px;
                }
            }
        }
    }

    .el-upload-list--picture-card .el-upload-list__item-thumbnail {
        width: 100%;
        height: auto;
    }
    .bill-form{
        .el-input{
            width: 480px
        }
    }
    
}


</style>
